import {Component, OnInit, Input, OnDestroy, EventEmitter, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {
  AbstractControl,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {FrtPackageTypesService} from 'src/app/services/frt-package-types/frt-package-types.service';
import {FrtShipmentPackageService} from 'src/app/services/frt-shipment-package/frt-shipment-package.service';
import {GridOptions} from 'ag-grid-community';
import {UserService} from 'src/app/services/user/user.service';
import {AppropriationChargeCodesService} from 'src/app/services/appropriation-charge-codes/appropriation-charge-codes.service';
import {FrtOtoAppChargeCodesComponent} from './frt-oto-appropriation-charge-codes/frt-oto-app-charge-codes.component';
import {User} from 'src/app/services/user/user';
import {Observable, SubscriptionLike} from 'rxjs';
import {PackageInformationService} from 'src/app/services/package-information/package-information.service';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import { DatePipe, NgClass } from "@angular/common";
import {TypeaheadModule} from "ngx-bootstrap/typeahead";
import {TabsModule} from "ngx-bootstrap/tabs";
import {AgGridAngular} from "ag-grid-angular";
import {FrtPackageTypesEntity, FrtShipmentPackagesEntity} from "../../../shared/common-components/common-structure";
import AppConstants from "../../../shared/common-components/AppConstants";
import {
  FrtShipmentHazmatModalComponent
} from "../../../shared/common-components/shipment/frt-shipment-item-modal/frt-shipment-item-modal.component";
import {
  ConfirmationModalComponent
} from "../../../shared/common-components/confirmation-modal/confirmation-modal.component";
@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BsDatepickerModule,
    TimepickerModule,
    TypeaheadModule,
    TabsModule,
    AgGridAngular
  ],
  selector: 'app-frt-oto-shipment-package-info-modal',
  templateUrl: './frt-oto-shipment-package-info.component.html',
  styleUrls: ['./frt-oto-shipment-package-info.component.css']
})
export class FrtOtoShipmentPackageInfoModalComponent implements OnInit, OnDestroy {

  // variables
  shipmentPackageTypes: FrtPackageTypesEntity[];
  shipmentPackageUserInputGroup: UntypedFormGroup;
  frtShipmentPackagesId: number;
  frtShipmentDetailsId: number;
  packageTypeDesc: any;
  shipmentPackageData: FrtShipmentPackagesEntity[] = [];
  packageClicked: boolean;
  packageClickedObject: FrtShipmentPackagesEntity;
  bookshipmentid: any;
  addInfoRequired = false;
  packageInfoGridOptions: GridOptions = this.initializeGridOptions();
  frtPackageInfoForm: UntypedFormGroup;
  currentUser: User;
  estimatedWeight: number;
  estimatedCubic: number;
  noOfFleetVehicles: number;
  fleetVehicleType: string;
  overWeight = false;
  overCubic = false;
  cummulativeWeight: number = 0;
  cummulativeCubic: number = 0;
  noPackages = false;
  carrierUser = false;
  carrierUserOrBOL = false;
  fromBOL = false;
  sroID: any;
  private user_subscription: SubscriptionLike;
  private readonly packageModalRef: BsModalRef;
  @Input() frtPackageDetailsCalledFrom: string;
  @Input() shipmentDetailsIdFromFrtBol: number;
  @Input() organizationId: number;
  @Input() ratesSroInfo: number;
  isOtoRequestMode = false;
  packages: FrtShipmentPackagesEntity[] = [];
  packageDraft: any;
  @Output() emitData = new EventEmitter<{packages: FrtShipmentPackagesEntity[]; isComplete: boolean; draft: any}>();
  sroType: any;
  validateCuFt: boolean;
  organizationID: number;
  avaiAppropriationChargeCodes: any[];
  assignedAppropriationChargeCodes: any[];
  chargeCodesList$: Observable<any>;

  constructor(
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private loader: LoadingService,
    private frtPackageTypesService: FrtPackageTypesService,
    private frtShipmentPackageService: FrtShipmentPackageService,
    private appropriationChargeCodesService: AppropriationChargeCodesService,
    private userService: UserService,
    public packageInformationService: PackageInformationService
  ) {
    this.packageModalRef = this.bsModalRef;
  }


  packageAddedColumnDefs = [
    {
      headerName: 'Select Package', sortable: true, width: 100, cellRenderer: params =>
        params.data ? '<a tabindex="0">Click Here</a>' : '',
      onCellClicked: (event: { data: FrtShipmentPackagesEntity; }) => this.onPackageClicked(event.data)
    },
    {
      headerName: 'Packages',
      children: [
        {headerName: 'Total Pieces', field: 'totalPieces', width: 100},
        {headerName: 'No. of Loose Pieces', field: 'noOfLoosePieces', width: 150},
        {headerName: 'Type', field: 'frtPackageTypesEntity.packageDescription', width: 100}
      ]
    },
    {headerName: 'Freight Commodity Description', field: 'commodityDesc', width: 220},
    {headerName: 'WEIGHT(Pounds Only)', field: 'packageWeight', width: 180},
    {headerName: 'CUBE*', field: 'cubicFeet', width: 100},
    {headerName: 'Truck Num', field: 'truckNum', width: 100},
    {
      headerName: 'HM', field: 'hazmatIndicator', width: 130,
      valueFormatter: (params) => params.data.hazmatIndicator === 1 ? 'Y' : 'N'
    },
    {
      headerName: 'Appropriate Charge Code(s)',
      field: 'appropriationChargeCode',
      width: 130
    }
  ];

  packageAddedRowData: FrtShipmentPackagesEntity[] = [];
  private emittedPackageData = false;

  initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'single',
      pagination: true,
      paginationPageSize: 10,
      domLayout: 'autoHeight',
      headerHeight: 40,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      }
    };
  }

  ngOnInit() {
    this.initializeForm();
    this.packageClicked = false;
    if (this.isOtoRequestMode) {
      this.sroType = 3;
      this.validateCuFt = false;
      this.organizationID = this.organizationId;
      this.packageAddedRowData = (this.packages || []).map(packageItem => ({
        ...packageItem,
        frtPackageTypesEntity: packageItem.frtPackageTypesEntity || this.shipmentPackageTypes?.find(type => type.packageTypeId === packageItem.packageTypeId)
      }));
      this.shipmentPackageData = this.packageAddedRowData;
      this.noPackages = this.packageAddedRowData.length === 0;
      if (this.packageDraft?.formValue) {
        this.frtPackageInfoForm.patchValue(this.packageDraft.formValue);
        this.assignedAppropriationChargeCodes = this.packageDraft.assignedChargeCodes || [];
        const selectedIndex = this.packageDraft.selectedPackageIndex;
        if (Number.isInteger(selectedIndex) && this.packageAddedRowData[selectedIndex]) {
          this.packageClickedObject = this.packageAddedRowData[selectedIndex];
          this.packageClicked = true;
        }
        if (this.frtPackageInfoForm.get('packageType').value) this.onPackageTypeChange();
      }
    }
    this.loader.show();
    if (!this.isOtoRequestMode) this.updateChargeCodes();
    this.updateDeletedChargeCodes();
    if (this.isOtoRequestMode && this.organizationID) {
      this.getAppropriationChargeCodesBasedOnOrganizationId();
    }
    this.user_subscription = this.userService.getCurrentUserObservable().subscribe(currentUser => {
      this.currentUser = currentUser;
      // If Carrier User logs in - make fields readonly
      if (currentUser && currentUser.roles && (currentUser.roles[0].role === 'Carrier User'
        || currentUser.roles[0].role === 'Carrier User Admin' || currentUser.roles[0].role === 'Carrier User RF')) {
        this.carrierUser = true;
        this.frtPackageInfoForm.get('totalPieces').disable();
        this.frtPackageInfoForm.get('noOfLoosePieces').disable();
        this.frtPackageInfoForm.get('noOfLoosePallets').disable();
        this.frtPackageInfoForm.get('packageType').disable();
        this.frtPackageInfoForm.get('freightCommodityDesc').disable();
        this.frtPackageInfoForm.get('weight').disable();
        this.frtPackageInfoForm.get('cube').disable();
        this.frtPackageInfoForm.get('chargebleCode').disable();
        this.frtPackageInfoForm.get('otherChargebleCode').disable();
        this.frtPackageInfoForm.get('truckNum').disable();
        this.frtPackageInfoForm.get('addtinfo').disable();
      }
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.info('unable to get current user details');
    });

    // get params
    // get package details
    /* this.route.queryParams.subscribe(queryparams => {
       this.frtShipmentDetailsId = queryparams['frtShipmentDetailsId'];
       this.bookshipmentid = queryparams['bookshipmentid'];
       this.organizationID = queryparams['organizationId'];
       this.sroType = Number(queryparams['ratesSroInfo'] );
       this.validateCuFt = (this.sroType === 1)? true : false;
       this.getAppropriationChargeCodesBasedOnOrganizationId();
       if (this.frtPackageDetailsCalledFrom === 'frtBOL') {
         this.frtShipmentDetailsId = this.shipmentDetailsIdFromFrtBol;
         this.fromBOL = true;
       }
       if (this.frtShipmentDetailsId) {
         this.getPackageData();
       } else {
         this.alertService.info('Unable to retrieve Shipment Details Id');
       }
     }, () => {
       this.loader.hide();
       this.alertService.error('There was an error retrieving Shipment Package Data');
     });*/

    // packageTypes
    this.frtPackageTypesService.getAllPackageTypes(this.frtShipmentDetailsId).subscribe(packageTypes => {
      this.shipmentPackageTypes = packageTypes;
      if (this.isOtoRequestMode) {
        this.packageAddedRowData = this.packageAddedRowData.map(packageItem => ({
          ...packageItem,
          frtPackageTypesEntity: packageItem.frtPackageTypesEntity || packageTypes.find(type => type.packageTypeId === packageItem.packageTypeId)
        }));
        this.shipmentPackageData = this.packageAddedRowData;
        if (this.frtPackageInfoForm.get('packageType').value) this.onPackageTypeChange();
      }
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Shipment Package Types');
    });

    // casting weight from FrtOnlineBookShipmentComponent
    if (!this.isOtoRequestMode) {
      this.frtShipmentPackageService.getEstimatedWeightFromBookShipment().subscribe(estWeight => this.estimatedWeight = estWeight);
      this.frtShipmentPackageService.getEstimatedCubicFromBookShipment().subscribe(estCubic => this.estimatedCubic = estCubic);
      this.frtShipmentPackageService.getFleetVehiclesFromBookShipment().subscribe(noOfVehicles => this.noOfFleetVehicles = noOfVehicles);
      this.frtShipmentPackageService.getVehicleTypeFromBookShipment().subscribe(vehicleType => this.fleetVehicleType = vehicleType);
      this.frtShipmentPackageService.getSroIDFromBookShipment().subscribe(sroId => this.sroID = sroId);
    }
    if (this.carrierUserOrBOL) {
      this.carrierUserOrBOL = true;
    } else {
      this.carrierUserOrBOL = false;
    }
  }

  updateDeletedChargeCodes() {
    this.packageInformationService.getDeletedChargeCodes().subscribe((data: any) => {
      if (this.assignedAppropriationChargeCodes) {
        const newAssignedList = this.assignedAppropriationChargeCodes.filter((x) =>
          !data.some((y) => (y.appropriationChargeCodesId === x.appropriationChargeCodesId))
        );
        this.assignedAppropriationChargeCodes = newAssignedList;
      }
    }, (error: any) => {
      console.log('cannot get observable');
    });
  }

  updateChargeCodes() {
    this.packageInformationService.getChargeCodes().subscribe((data) => {
      this.avaiAppropriationChargeCodes = data;
    });
  }

  getAppropriationChargeCodesBasedOnOrganizationId() {
    if (!AppConstants.isNotNullCondition(this.frtPackageDetailsCalledFrom)) {
      this.appropriationChargeCodesService.getAppropriationChargeCodesByOrganizationId(this.organizationID).subscribe((data: any) => {
        this.avaiAppropriationChargeCodes = data;
      }, (error: any) => {
        this.alertService.error('There was an error retrieving agencyName List');
      });
    }
  }

  initializeForm() {
    this.frtPackageInfoForm = this.fb.group({
      totalPieces: new UntypedFormControl(null, [Validators.required,Validators.min(1), Validators.maxLength(5),
        Validators.pattern('^[1-9]\\d*(\\.\\d+)?$'),(control: AbstractControl) => this.customChangeValidator(control)]
      ),
      noOfLoosePieces: new UntypedFormControl(null, [Validators.maxLength(5)]),
      noOfLoosePallets: new UntypedFormControl(null, [Validators.maxLength(5)]),
      packageType: new UntypedFormControl(null, Validators.required),
      freightCommodityDesc: new UntypedFormControl(null, Validators.required),
      weight: new UntypedFormControl(null, [Validators.required, Validators.maxLength(5)]),
      cube: new UntypedFormControl(null, [Validators.maxLength(5)]),
      chargebleCode: new UntypedFormControl(null),
      otherChargebleCode: new UntypedFormControl(null),
      truckNum: new UntypedFormControl(1, Validators.required),
      addtinfo: new UntypedFormControl(),
      appChargeCodes: new UntypedFormControl(null),
      assignedChargeCodes: new UntypedFormControl(null)
    });
  }

  customChangeValidator(ctrl: AbstractControl){
    const value = ctrl.value;
    if((this.sroType === 2) && (null !== value)){
      if((Math.abs(this.getTotalPieceFromTable())) > this.noOfFleetVehicles) return {totalPieceErr: true};
      return null;
    }
    return null;
  }

  getPackageData() {
    this.loader.show();
    this.frtShipmentPackageService.getShipmentPackagesByShipmentDetailsId(this.frtShipmentDetailsId).subscribe(packageData => {
      this.loader.hide();
      if (packageData) {
        this.noPackages = false;
      } else {
        this.noPackages = true;
      }
      this.shipmentPackageData = packageData;
      this.packageAddedRowData = this.shipmentPackageData;
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Shipment Package Details');
    });
  }

  onPackageTypeChange() {
    const packageType: FrtPackageTypesEntity = this.shipmentPackageTypes.find(x => {
      return x.packageTypeId === this.frtPackageInfoForm.get('packageType').value;
    });
    if (packageType?.packageDescription === 'other') {
      this.frtPackageInfoForm.get('addtinfo').setValidators(Validators.required);
      this.frtPackageInfoForm.get('addtinfo').updateValueAndValidity();
      this.addInfoRequired = true;
    } else {
      this.frtPackageInfoForm.get('addtinfo').clearValidators();
      this.frtPackageInfoForm.get('addtinfo').updateValueAndValidity();
      this.addInfoRequired = false;
    }
  }

  onPackageClicked(shipmentPackageSelectedItem: FrtShipmentPackagesEntity) {
    this.packageClickedObject = shipmentPackageSelectedItem;
    if (this.carrierUser || this.frtPackageDetailsCalledFrom === 'frtBOL') {
      this.openAddEditItem();
    } else {
      this.frtPackageInfoForm.get('totalPieces').setValue(shipmentPackageSelectedItem.totalPieces);
      this.frtPackageInfoForm.get('noOfLoosePieces').setValue(shipmentPackageSelectedItem.noOfLoosePieces);
      this.frtPackageInfoForm.get('noOfLoosePallets').setValue(shipmentPackageSelectedItem.noOfPallets);
      this.frtPackageInfoForm.get('packageType').setValue(shipmentPackageSelectedItem.packageTypeId);
      this.frtPackageInfoForm.get('freightCommodityDesc').setValue(shipmentPackageSelectedItem.commodityDesc);
      this.frtPackageInfoForm.get('weight').setValue(shipmentPackageSelectedItem.packageWeight);
      this.frtPackageInfoForm.get('cube').setValue(shipmentPackageSelectedItem.cubicFeet);
      this.frtPackageInfoForm.get('chargebleCode').setValue(shipmentPackageSelectedItem.appropriationChargeCode);
      this.frtPackageInfoForm.get('otherChargebleCode').setValue(shipmentPackageSelectedItem.otherAppropriationChargeCode);
      this.frtPackageInfoForm.get('truckNum').setValue(shipmentPackageSelectedItem.truckNum);
      this.frtPackageInfoForm.get('addtinfo').setValue(shipmentPackageSelectedItem.additionalComments);
      this.getAssignedChargeCodeFromPackageData(shipmentPackageSelectedItem);
      this.packageClicked = true;
    }
  }

  getAssignedChargeCodeFromPackageData(assignedChargeCodes: any) {
    if (assignedChargeCodes.appropriationChargeCode && assignedChargeCodes.appropriationChargeCode.length > 0) {
      this.appropriationChargeCodesService.getAppropriationChargeCodesByChargeCodes(assignedChargeCodes.appropriationChargeCode).subscribe((data: any) => {
        this.assignedAppropriationChargeCodes = data;
      }, (err: any) => {
      });
    }
  }

  onPackageDetailRowClicked(event: any) {
    const initialState = {
      itemModalCalledFrom: 'frtBOL'
    };
    this.bsModalRef = this.modalService.show(FrtShipmentHazmatModalComponent, {initialState, class: 'modal-lg'});
  }

  onTruckNumChange() {

  }

  openAddEditItem() {
    const initialState = {
      shipmentPackage: this.packageClickedObject,
      isUserFromCarrierOrBOL: this.fromBOL
    };
    this.bsModalRef = this.modalService.show(FrtShipmentHazmatModalComponent, {initialState, class: 'modal-lg'});
    this.bsModalRef.content.modalCloseEvent.subscribe((data: any) => {
      if(data === 'reload'){
        this.getPackageData();
      }
    });
  }

  calculateCummulativeWeight() {
    this.cummulativeWeight = 0;
    for (const shipmentpack of this.shipmentPackageData || []) {
      this.cummulativeWeight += Number(shipmentpack.packageWeight || 0);
    }
    if (this.packageClicked) {
      this.cummulativeWeight = this.cummulativeWeight - Number(this.packageClickedObject.packageWeight || 0) + Number(this.frtPackageInfoForm.get('weight').value || 0);
    }else{
      this.cummulativeWeight = Number(this.frtPackageInfoForm.get('weight').value || 0) + this.cummulativeWeight;
    }
  }

  calculateCummulativeCubic() {
    this.cummulativeCubic = 0;
    for (const shipmentpack of this.shipmentPackageData || []) {
      this.cummulativeCubic += Number(shipmentpack.cubicFeet || 0);
    }
    const cuFtVal = (this.frtPackageInfoForm.get('cube').value === null) ? 0 : (this.frtPackageInfoForm.get('cube').value);
    if (this.packageClicked) {
      this.cummulativeCubic = this.cummulativeCubic - Number(this.packageClickedObject.cubicFeet || 0) + Number(cuFtVal || 0);
    }else{
      this.cummulativeCubic = Number(cuFtVal || 0) + this.cummulativeCubic;
    }

  }

  getAssignedChargeCodes() {
    if (this.assignedAppropriationChargeCodes && this.assignedAppropriationChargeCodes.length > 0) {
      const chargeCodes = this.assignedAppropriationChargeCodes.map((item) => {
        return item.chargeCode;
      });
      return chargeCodes.toString();
    } else {
      return null;
    }
  }

  onSaveOrEditClicked(modifyType: string) {
    if (this.frtPackageInfoForm.invalid) {
      this.frtPackageInfoForm.markAllAsTouched();
      return;
    }
    const shipmentPackage = new FrtShipmentPackagesEntity;
    shipmentPackage.frtShipmentDetailsId = this.frtShipmentDetailsId;
    shipmentPackage.packageTypeId = this.frtPackageInfoForm.get('packageType').value;
    shipmentPackage.totalPieces = this.frtPackageInfoForm.get('totalPieces').value;
    shipmentPackage.noOfLoosePieces = this.frtPackageInfoForm.get('noOfLoosePieces').value;
    shipmentPackage.noOfPallets = this.frtPackageInfoForm.get('noOfLoosePallets').value;
    shipmentPackage.packageWeight = this.frtPackageInfoForm.get('weight').value;
    shipmentPackage.cubicFeet = this.frtPackageInfoForm.get('cube').value;
    shipmentPackage.commodityDesc = this.frtPackageInfoForm.get('freightCommodityDesc').value;
    shipmentPackage.truckNum = this.frtPackageInfoForm.get('truckNum').value;
    shipmentPackage.additionalComments = this.frtPackageInfoForm.get('addtinfo').value;
    shipmentPackage.appropriationChargeCode = this.getAssignedChargeCodes();
    shipmentPackage.otherAppropriationChargeCode = this.frtPackageInfoForm.get('otherChargebleCode').value;
    shipmentPackage.hazmatIndicator = this.packageClickedObject?.hazmatIndicator || 0;
    shipmentPackage.frtPackageTypesEntity = this.shipmentPackageTypes?.find(type => type.packageTypeId === shipmentPackage.packageTypeId);

    if (this.isOtoRequestMode) {
      if (modifyType === 'update' && this.packageClickedObject) {
        this.packageAddedRowData = this.packageAddedRowData.map(pack =>
          pack === this.packageClickedObject ? {...this.packageClickedObject, ...shipmentPackage} : pack
        );
      } else {
        this.packageAddedRowData = [...this.packageAddedRowData, shipmentPackage];
      }
      this.shipmentPackageData = this.packageAddedRowData as FrtShipmentPackagesEntity[];
      this.noPackages = this.packageAddedRowData.length === 0;
      this.onResetClicked();
      return;
    }

    console.log(this.frtPackageInfoForm.valid);
    if (modifyType === 'update') {
      shipmentPackage.frtShipmentPackagesId = this.packageClickedObject.frtShipmentPackagesId;
      shipmentPackage.hazmatIndicator = this.packageClickedObject.hazmatIndicator;
      // API call for Editing package
      this.loader.show();
      this.frtShipmentPackageService.updateShipmentPackageEntity(shipmentPackage).subscribe(newShipmentObjectUpdateData => {
        this.packageClickedObject = newShipmentObjectUpdateData;
        this.loader.hide();
        // update list
        this.getPackageData();
        this.alertService.success('The Shipment Package has been successfully Updated');
        this.onResetClicked();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error Updating Shipment Package');
      });
    } else if (modifyType === 'save') {
      shipmentPackage.hazmatIndicator = 0;
      // API call for Saving package
      this.loader.show();
      this.frtShipmentPackageService.saveShipmentPackageEntity(shipmentPackage).subscribe(newShipmentObjectSaveData => {
        this.packageClickedObject = newShipmentObjectSaveData;
        this.loader.hide();
        // update list
        this.getPackageData();
        this.alertService.success('The Shipment Package has been successfully Added');
        this.onResetClicked();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error Adding Shipment Package');
      });
      this.packageClicked = true;
    }
  }

  onResetClicked() {
    // this.frtPackageInfoForm.reset();
    this.frtPackageInfoForm.get('packageType').setValue(null);
    this.frtPackageInfoForm.get('totalPieces').setValue(null);
    this.frtPackageInfoForm.get('noOfLoosePieces').setValue(null);
    this.frtPackageInfoForm.get('noOfLoosePallets').setValue(null);
    this.frtPackageInfoForm.get('weight').setValue(null);
    this.frtPackageInfoForm.get('cube').setValue(null);
    this.frtPackageInfoForm.get('freightCommodityDesc').setValue(null);
    this.frtPackageInfoForm.get('addtinfo').setValue(null);
    this.frtPackageInfoForm.get('chargebleCode').setValue(null);
    this.frtPackageInfoForm.get('otherChargebleCode').setValue(null);
    this.frtPackageInfoForm.get('truckNum').setValue(1);
    this.packageClicked = false;
    this.overWeight = false;
    this.overCubic = false;
    this.packageClickedObject = null;
    this.frtPackageInfoForm.get('weight').setErrors(null);
    this.frtPackageInfoForm.get('cube').setErrors(null);
  }

  onDeleteClicked() {
    const packId = this.packageClickedObject.frtShipmentPackagesId;
    if (this.isOtoRequestMode) {
      this.packageAddedRowData = this.packageAddedRowData.filter(pack => pack !== this.packageClickedObject);
      this.shipmentPackageData = this.packageAddedRowData as FrtShipmentPackagesEntity[];
      this.noPackages = this.packageAddedRowData.length === 0;
      this.onResetClicked();
      return;
    }
    // User clicked Delete from the Destination List
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'Are you sure, you want to delete Shipment Package and Related Items?';
    this.bsModalRef.content.title = 'Package Delete';
    this.bsModalRef.content.confirmText = 'Yes';
    this.bsModalRef.content.cancelText = 'No';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        this.frtShipmentPackageService.deleteShipmentPackageEntity(packId).subscribe(() => {
          this.loader.hide();
          this.alertService.success('Successfully deleted Shipment Package and Respective Items');
          this.getPackageData();
          this.onResetClicked();
        }, () => {
          this.loader.hide();
          this.alertService.error('There was an error Deleting Shipment Package');
        });
      }
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error executing Delete Shipment Package Modal');
    });
  }

  onContinueClicked() {
    if (this.isOtoRequestMode) {
      const validationMessage = this.getOtoPackageValidationMessage();
      if (!this.packageAddedRowData.length) {
        this.alertService.info(validationMessage);
        return;
      }
      // The OTO modal commits the package table back to its parent; the parent's
      // request Submit action consumes these entities for the API payload.
      this.emitOtoPackageData(!validationMessage);
      if (validationMessage) this.alertService.info(validationMessage);
      this.packageModalRef.hide();
      return;
    }
    this.packageModalRef.hide();
    /*const errCub = this.onCubeValidation();
    if(AppConstants.isNotNullCondition(errCub) && errCub !== '<br>'){
      this.alertService.info(errCub);
    }else{
        this.onResetClicked();
        this.router.navigate(['/frtbookshipment'], {
          queryParams: {bookshipmentid: this.bookshipmentid}
        });
    }*/
  }

  closePackageModal(): void {
    if (this.isOtoRequestMode) {
      this.emitOtoPackageData(!this.getOtoPackageValidationMessage());
    }
    this.packageModalRef.hide();
  }

  private emitOtoPackageData(isComplete: boolean): void {
    this.emittedPackageData = true;
    this.emitData.emit({
      packages: [...this.packageAddedRowData],
      isComplete,
      draft: {
        formValue: this.frtPackageInfoForm?.getRawValue(),
        assignedChargeCodes: this.assignedAppropriationChargeCodes || [],
        selectedPackageIndex: this.packageClickedObject ? this.packageAddedRowData.indexOf(this.packageClickedObject) : -1
      }
    });
  }

  private getOtoPackageValidationMessage(): string {
    if (!this.packageAddedRowData.length) return 'Add at least one package before submitting.';
    const totalWeight = this.packageAddedRowData.reduce((total, item) => total + Number(item.packageWeight || 0), 0);
    const expectedWeight = Number(this.estimatedWeight);
    if (Number.isFinite(expectedWeight) && Math.abs(totalWeight - expectedWeight) > 0.001) {
      return `Package weights must total the estimated shipment weight (${this.estimatedWeight} lbs). Current package total: ${totalWeight} lbs.`;
    }
    const expectedCubic = Number(this.estimatedCubic);
    if (this.validateCuFt && Number.isFinite(expectedCubic)) {
      const totalCubic = this.packageAddedRowData.reduce((total, item) => total + Number(item.cubicFeet || 0), 0);
      if (Math.abs(totalCubic - expectedCubic) > 0.001) {
        return `Package cubic feet must total the estimated shipment cubic feet (${this.estimatedCubic}). Current package total: ${totalCubic}.`;
      }
    }
    return '';
  }

  ngOnDestroy(): void {
    if (this.isOtoRequestMode && !this.emittedPackageData) {
      this.emitOtoPackageData(!this.getOtoPackageValidationMessage());
    }
    this.packageInformationService.setChargeCodes(null);
    this.packageInformationService.setDeletedChargeCodes(null);
  }

  onCubeValidation() {
    let errCubicMessage = "";
    let errWeightMessage = "";
    let totalCubFt = 0;
    let totalWeight = 0;
    for (const shipmentpack of this.shipmentPackageData) {
      totalCubFt += shipmentpack.cubicFeet;
      totalWeight += shipmentpack.packageWeight;
    }
    const cubicDifference = Math.abs(this.estimatedCubic - totalCubFt);
    if (this.estimatedCubic === totalCubFt) {
      errCubicMessage = "";
    } else if (this.estimatedCubic > totalCubFt) {
      errCubicMessage = 'The cummulative Cubic is ' + cubicDifference + ' Less than the Estimated Cubic';
    } else if (this.estimatedCubic < totalCubFt) {
      errCubicMessage = 'The cummulative Cubic is ' + cubicDifference + ' More than the Estimated Cubic';
    }

    const weightDifference = Math.abs(this.estimatedWeight - totalWeight);
    if (this.estimatedWeight === totalWeight) {
      errWeightMessage="";
    } else if (this.estimatedWeight > totalWeight) {
      errWeightMessage = 'The cummulative packages weight is ' + weightDifference + ' Less than the Estimated weight';
    } else if (this.estimatedWeight < totalWeight) {
      errWeightMessage = 'The cummulative packages weight is ' + weightDifference + ' More than the Estimated weight';
    }

    return ((this.validateCuFt) ? errCubicMessage : '') + '<br>'+ errWeightMessage;
  }

  onWeightValidation(){
    let errWeightMessage = "";
    const weightDifference = Math.abs(this.estimatedWeight - this.cummulativeWeight);
    if (this.estimatedWeight === this.cummulativeWeight) {
      errWeightMessage="";
    } else if (this.estimatedWeight > this.cummulativeWeight) {
      errWeightMessage = 'The cummulative packages weight is ' + weightDifference + ' Less than the Estimated weight';
    } else if (this.estimatedWeight < this.cummulativeWeight) {
      errWeightMessage = 'The cummulative packages weight is ' + weightDifference + ' More than the Estimated weight';
    }
    return errWeightMessage;
  }

  onWeightChange() {
    this.calculateCummulativeWeight();
    if (this.estimatedWeight > this.cummulativeWeight || this.estimatedWeight === this.cummulativeWeight) {
      this.overWeight = false;
      this.frtPackageInfoForm.get('weight').setErrors(null);
    } else if (this.estimatedWeight < this.cummulativeWeight) {
      this.overWeight = true;
      this.frtPackageInfoForm.get('weight').setErrors({overW: true});
    }
  }

  onCubicChange(){
    if(this.validateCuFt){
      this.calculateCummulativeCubic();
      if (this.estimatedCubic > this.cummulativeCubic || this.estimatedCubic === this.cummulativeCubic) {
        this.overCubic = false;
        this.frtPackageInfoForm.get('cube').setErrors(null);
      } else if (this.estimatedCubic < this.cummulativeCubic) {
        this.overCubic = true;
        this.frtPackageInfoForm.get('cube').setErrors({overC: true});
      }
    }
  }

  moveItems() {
    const sourceArray = this.frtPackageInfoForm.get('appChargeCodes').value;
    const appChargeCodes = [];
    const destinationArray = AppConstants.isNotNullCondition(this.assignedAppropriationChargeCodes) ? this.assignedAppropriationChargeCodes : [];
    this.avaiAppropriationChargeCodes.forEach(e => {
      sourceArray.forEach(y => {
        const isPresent = destinationArray.find(x => x.chargeCode === y);
        if (e.chargeCode === y && !isPresent) {
          appChargeCodes.push(e);
        }
      });
    });
    this.assignedAppropriationChargeCodes = Array.from(new Set(destinationArray.concat(appChargeCodes)));
  }

  handleRateTypesMultiDropdown(i: any) {
    this.assignedAppropriationChargeCodes.splice(i, 1);
  }

  onManageChargeCodeClicked() {
    const initialState = {
      currentUser: this.currentUser
    };
    this.bsModalRef = this.modalService.show(FrtOtoAppChargeCodesComponent, {initialState, class: 'modal-lg'});
  }

  getTotalPieceFromTable(){
    let totalPieces = 0;
    if(this.packageAddedRowData.length > 0){
      this.packageAddedRowData.forEach((e:any) => {
        totalPieces += e.totalPieces;
      })
    }
    if (this.packageClicked) {
      totalPieces = totalPieces - this.packageClickedObject.totalPieces + parseInt(this.frtPackageInfoForm.get('totalPieces').value);
    }else{
      totalPieces = totalPieces + parseInt(this.frtPackageInfoForm.get('totalPieces').value);
    }
    return totalPieces;
  }


}
